import hostname from './getHostname'
import isDevelopment from './isDevelopment'

const usePorts = isDevelopment && hostname.indexOf('.test') === -1

const serviceEndpoints = {
  sessions: `${hostname + (usePorts ? ':3001' : '')}/sessions`,
  administrators: `${hostname + (usePorts ? ':3001' : '')}/administrators`,
  notifications: `${hostname + (usePorts ? ':3002' : '')}/notifications`,
  forms: `${hostname + (usePorts ? ':3003' : '')}/forms`,
  customers: `${hostname + (usePorts ? ':3004' : '')}/customers`,
  users: `${hostname + (usePorts ? ':3005' : '')}/users`,
  importers: `${hostname + (usePorts ? ':3006' : '')}/importers`,
  statistics: `${hostname + (usePorts ? ':3007' : '')}/statistics`,
  messages: `${hostname + (usePorts ? ':3008' : '')}/messages`,
  files: `${hostname + (usePorts ? ':3009' : '')}/files`,
}

export default serviceEndpoints
